var $=jQuery;
$(document).ready(function ($) {
   $("span.btn-close").on("click", function(){
    $('.notification_bar').slideUp();
  });
    $(".category-sub-custom .facets__summary-label").on("click", function(){
    $(this).closest(".category-sub-custom").toggleClass("active");
  });

  // $('.has_slider .hero-sewing__brands-inner').flickity({
  //   cellAlign: 'left',
  //   contain: true,
  //   wrapAround: true,
  //   autoPlay: 2000,
  //   prevNextButtons: true,
  //   pageDots: false,
  //   imagesLoaded: true,
  //   adaptiveHeight: false
  // });
  function slider_mobile() {
    if($(window).width() <= 949){
      $(".nt_slide_mobi .multicolumn-list ").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
      $(".uber-multicolumn-st  .multicolumn-list ").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });

      $(".hero-sewing__brands-inner,.brand-logos-slider-new").flickity({
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          autoPlay: 7000,
          groupCells: false,
          cellAlign: 'left',
      });
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
    var thumbItems = $('.product-single__thumbnails li').length;

if (thumbItems > 5) {
    $('.product-single__thumbnails').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false
    });
}
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  
        $thumbnails.eq(index).addClass('active');  
    });
    $('.product-single__thumbnails li').first().addClass('active');
  
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index); 
    });
});

$('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });

//price custom
class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      // Event listeners for text input focus and change
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      // Event listeners for range slider change and input
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
}
window.customElements.define("price-range1", PriceRange1);

// document.addEventListener("DOMContentLoaded", function () {
//   const thumbnails = document.querySelectorAll(".product-single__thumbnails-item");
//   const container = document.querySelector(".product-single__thumbnails");

//   thumbnails.forEach((thumb) => {
//     thumb.addEventListener("click", function () {
//       thumbnails.forEach((t) => t.classList.remove("active"));
//       this.classList.add("active");

//       const containerRect = container.getBoundingClientRect();
//       const thumbRect = this.getBoundingClientRect();

//       if (thumbRect.left < containerRect.left || thumbRect.right > containerRect.right) {
//         container.scrollTo({
//           left:
//             this.offsetLeft -
//             container.clientWidth / 2 +
//             this.clientWidth / 2,
//           behavior: "smooth",
//         });
//       }
//     });
//   });
// });



// load varaint 
$(window).on('load', function() {
  // Locate the script tag containing variant data
  const scriptTag = $('script[data-selected-variant]').first();

  if (scriptTag.length) {
    try {
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;
      const sectionIdValue = $('input[name="section-id"]').val();
      
      // Ensure we have both IDs before proceeding
      if (featuredMediaId && sectionIdValue) {
        const mediaId = `${sectionIdValue}-${featuredMediaId}`;
        const thumbnail = $(`li[data-att="${mediaId}"]`);

        if (thumbnail.length) {
          console.log('Thumbnail found, waiting for Flickity...');

          // --- FIX: Polling mechanism to wait for Flickity initialization ---
          const checkFlickityInterval = setInterval(() => {
            const $gallery = $('.product-single__gallery');
            const flkty = $gallery.data('flickity');

            // Check if Flickity is fully initialized and has cells
            if (flkty && flkty.cells && flkty.cells.length > 0) {
              clearInterval(checkFlickityInterval); // Stop checking
              console.log('Flickity ready. Triggering click.');
              thumbnail.click(); // Trigger the click safely
            }
          }, 100); // Check every 100ms

          // Safety timeout: Stop checking after 5 seconds to prevent infinite loops
          setTimeout(() => {
            clearInterval(checkFlickityInterval);
          }, 1000);
        }
      }
    } catch (e) {
      console.error('Error parsing variant JSON:', e);
    }
  }
});


// load varaint 

$(document).ready(function() {
    const $slider = $('.hero-sewing__brands-inner');
    let isDown = false;
    let startX;
    let scrollLeft;
    let velocity = 0;
    let rafID;

    $slider.on('mousedown', function(e) {
        isDown = true;
        $slider.addClass('active');
        startX = e.pageX - $slider.offset().left;
        scrollLeft = $slider.scrollLeft();
        cancelAnimationFrame(rafID); 
    });

    $(window).on('mouseup blur', function() {
        if (!isDown) return;
        isDown = false;
        $slider.removeClass('active');
        beginMomentum(); 
    });

    $slider.on('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - $slider.offset().left;
        const walk = (x - startX) * 2;
        
        const prevScrollLeft = $slider.scrollLeft();
        $slider.scrollLeft(scrollLeft - walk);
        
        velocity = $slider.scrollLeft() - prevScrollLeft;
    });

    function beginMomentum() {
        if (Math.abs(velocity) > 0.5) {
            $slider.scrollLeft($slider.scrollLeft() + velocity);
            velocity *= 0.95; 
            rafID = requestAnimationFrame(beginMomentum);
        }
    }

    $slider.on('wheel', function(e) {
        if (e.originalEvent.deltaY !== 0) {
            e.preventDefault();
            $slider.stop().animate({
                scrollLeft: $slider.scrollLeft() + e.originalEvent.deltaY * 2
            }, 200);
        }
    });
});
$(document).ready(function() {
    const $slider = $('.brand-logos-slider-new');
    if (!$slider.length) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let velocity = 0;
    let rafID;

    $slider.on('mousedown', function(e) {
        isDown = true;
        $slider.addClass('active');
        startX = e.pageX - $slider.offset().left;
        scrollLeft = $slider.scrollLeft();
        cancelAnimationFrame(rafID);
    });

    $(window).on('mouseup blur', function() {
        if (!isDown) return;
        isDown = false;
        $slider.removeClass('active');
        applyMomentum();
    });

    $slider.on('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - $slider.offset().left;
        const walk = (x - startX) * 1.5; 
        
        const prevScroll = $slider.scrollLeft();
        $slider.scrollLeft(scrollLeft - walk);
        velocity = $slider.scrollLeft() - prevScroll;
    });

    function applyMomentum() {
        if (Math.abs(velocity) > 0.5) {
            $slider.scrollLeft($slider.scrollLeft() + velocity);
            velocity *= 0.95; 
            rafID = requestAnimationFrame(applyMomentum);
        }
    }

    $slider.on('wheel', function(e) {
        if (e.originalEvent.deltaY !== 0) {
            e.preventDefault();
            const delta = e.originalEvent.deltaY;
            $slider.stop().animate({
                scrollLeft: $slider.scrollLeft() + delta
            }, 300);
        }
    });
});